function initProductList() {
  document.addEventListener('click', function (e) {
    const colorEl = e.target.closest('.thumbnails img');
    const sizeEl = e.target.closest('.sizes span');

    if (colorEl || sizeEl) {
      const card = (colorEl || sizeEl).closest('.product-card');
      const variants = JSON.parse(card.querySelector('.product-variants').textContent);

      // Get selected color + size
      const activeColor = card.querySelector('.thumbnails img.active')?.dataset.color;
      const activeSize = card.querySelector('.sizes span.active')?.dataset.size;

      // Mark active UI
      if (colorEl) {
        card.querySelectorAll('.thumbnails img').forEach(img => img.classList.remove('active'));
        colorEl.classList.add('active');
      }
      if (sizeEl) {
        card.querySelectorAll('.sizes span').forEach(span => span.classList.remove('active'));
        sizeEl.classList.add('active');
      }

      // Re-read selections after marking active
      const color = card.querySelector('.thumbnails img.active')?.dataset.color;
      const size = card.querySelector('.sizes span.active')?.dataset.size;

      // Find matching variant
      const match = variants.find(v =>
        (!color || v.option1 === color) &&
        (!size || v.option2 === size)
      );

      // Update hidden input with correct variant ID
      if (match) {
        const input = card.querySelector('.product-variant-id');
        if (input) input.value = match.id;
      }
    }
  });
}
document.addEventListener('DOMContentLoaded', initProductList);
